import { AutenticacionModule } from './modulos/autenticacion/autenticacion.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { VisitantesModule } from './modulos/visitantes/visitantes.module';
import { AreasModule } from './modulos/areas/areas.module';
import { UsuariosModule } from './modulos/usuarios/usuarios.module';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { LugaresModule } from './modulos/lugares/lugares.module';
import { ComponentesCompartidosModule } from './modulos/componentes-compartidos/componentes-compartidos.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptorService } from './interceptores/auth-interceptor.service';
import { ToastrModule } from 'ngx-toastr';
import { DndDirective } from './directivas/dnd.directive';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    VisitantesModule,
    UsuariosModule,
    AutenticacionModule,
    LugaresModule,
    AreasModule,
    NoopAnimationsModule,
    ComponentesCompartidosModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
